import { Component, OnInit, ElementRef } from '@angular/core';
import { Platform, NavController, MenuController, AngularDelegate } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { ActionSheetController } from '@ionic/angular';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { Base64 } from '@ionic-native/base64/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { IOSFilePicker } from '@ionic-native/file-picker/ngx';
import { DomSanitizer } from '@angular/platform-browser';
import { IfscValidator } from 'src/app/validation/ifsc.validator';
import { convertActionBinding } from '@angular/compiler/src/compiler_util/expression_converter';
import { StatusBar } from '@ionic-native/status-bar/ngx';

@Component({
  selector: 'app-updatename',
  templateUrl: './updatename.page.html',
  styleUrls: ['./updatename.page.scss'],
})
export class UpdatenamePage implements OnInit {
  public changename: FormGroup;
  languageConext: any;
  context: any;
  headingTitle: any;
  selectedApplicable: any;
  oldname: any;// for change name 
  newname: any="";// for change name 
  applicable: any=[];//for change name
  selproof: any;// for change name
  selproofAdditional: any;
  namematch: boolean = false;// for change name 
  TrustFrontImgFile: any; // for change name 
  TrustBackImgFile: any;// for change name 
  FrontImgFile: any;// for change name 
  BackImgFile: any;// for change name 
  FronImgName: any;// for change name 
  BackImgName: any;// for change name 
  formsubmitted: boolean = false;


  TrustFrontImgFileAdd: any; // for additional options
  AddtionalFile: boolean = false;
  FileSelected: any;// for change name 
  Filearray: any;// for change name 
  agreecheck: any = false;
  file1: any = {};
  file2: any = {};
  file3: any = {};
  file4: any = {};
  file5: any = {};
  fileArray: any = [];
  userInfo: any;
  response: any;
  nameDiv = true;
  normaldropdown: boolean = true;
  nomineedropdown: boolean = false;
  appointeedropdown: boolean = false;
  appointees: any = [];
  nominees: any = [];
  applname: any;
  additionalproofimgs: any = []
  additionalprooftrustimgs: any = [];
  combineimgary: any = [];
  constructor(
    private router: Router,
    public formBuilder: FormBuilder,
    public api: RestapiService,
    public _sanitizer: DomSanitizer,
    public navctrl: NavController,
    public platform: Platform,
    public cmndeclaration: CommonDeclarationService,
    public cmndef: CommonDefinitionService,
    public menuCtrl: MenuController,
    public actionVal: ActionlistenService,
    public camera: Camera,
    public file: File,
    public actionSheetController: ActionSheetController,
    public base64: Base64,
    public filePath: FilePath,
    public fileChooser: FileChooser,
    public iosfilepicker: IOSFilePicker,
    public statusBar: StatusBar
  ) {
    if (this.cmndeclaration.LanguageJson) {
      this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].changename;
    }
    else {
      this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
      this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].changename;
    }
    this.headingTitle = this.languageConext.heading.label;
    // this.applicable = this.languageConext.nameselet;
    this.api.postapi("getPopupConfigs", {}).then(data => {
      console.log(data);
      localStorage.configPage = JSON.stringify(data);
    }, err => {
      console.log("err");
    })


    this.changename = formBuilder.group({
      newname: ['', Validators.required],
      applicable: ['', Validators.required],
      oldname: ['', Validators.required],
      selproof: ['', Validators.required],
      selproofAdditional: ['', ''],
      agreecheck: []
    });

    this.cmndeclaration.getstoreProcess('profile').then(async data => {
      this.userInfo = data;
      var req = {
        "userSessionID": localStorage.userSessionID,
        "userChatSessionId": localStorage.userChatSessionId,
        "mobileNo": this.userInfo.mobileNo,
        "requestType": "getDOBDetails",
      }
      await this.cmndef.loaderstart();
      await this.api.postapi("updateDetails", req).then(response => {
        if (response['responseCode'] == '001' || response['responseCode'] == null) {
          console.log(response);
          this.response = response;
          for (let i = 0; i < this.languageConext.nameselet.length; i++) {
            let data1 = this.languageConext.nameselet[i].value;
            if (data1 == "policyowner") {
              if ((this.response.policyowner.length != undefined && this.response.policyowner.length>0) || (this.response.policyowner.name != undefined && this.response.policyowner.name != '' && this.response.policyowner.name != 'null' && this.response.policyowner.name != null))
                this.applicable.push(this.languageConext.nameselet[i]);
            } else if (data1 == "nominee") {
              if((this.response.nominee.length && this.response.nominee.length>0) || (this.response.nominee.name != undefined && this.response.nominee.name != '' && this.response.nominee.name != 'null' && this.response.nominee.name != null))
                this.applicable.push(this.languageConext.nameselet[i]);
            } else if (data1 == "appointee") {
              if((this.response.appointee.length && this.response.appointee.length>0) || (this.response.appointee.name != undefined && this.response.appointee.name != '' && this.response.appointee.name != 'null' && this.response.appointee.name != null))
                this.applicable.push(this.languageConext.nameselet[i]);
            }
          }
          setTimeout(()=>{
            this.selectedApplicable = "policyowner";
            this.cmndef.loaderend();
          },2000);
        }
      }, err => {
        console.log(err);
        this.cmndef.loaderend();
      })
    });
  }
  ionViewWillEnter() {
    this.menuCtrl.swipeEnable(false);
  }

  changeapplicant(type, selecttype) {
    console.log(selecttype.detail.value);
    if (type == 'nominee') {
      for (var i = 0; i < this.response.nominee.length; i++) {
        if (this.response.nominee[i].name == selecttype.detail.value) {
          this.oldname = this.response.nominee[i].oldname;
          console.log("nominee old name", this.oldname);
        }
      }
    }
    else if (type == 'appointee') {
      console.log(selecttype.detail.value);
      for (var i = 0; i < this.response.appointee.length; i++) {
        if (this.response.appointee[i].name == selecttype.detail.value) {
          this.oldname = this.response.appointee[i].oldname;
          console.log("appointee old name", this.oldname);
        }
      }

    }

  }

  async changeAppType(selected) {

    console.log(this.changename.get('newname'))

    //added by gokul

    this.selectedApplicable = selected;
    this.newname = "";
    this.agreecheck = false;
    this.selproof = "";
    this.formsubmitted = false;
    this.file1 = {};
    this.file2 = {};
    this.additionalproofimgs = [];
    this.selproofAdditional = '';
    this.oldname = "";

    this.changename.controls.selproof.reset();
    this.changename.controls.newname.reset();

    if (selected === 'policyowner') {
      console.log(this.response);
      console.log(this.response.policyowner);
      if (this.response.policyowner.name == undefined || this.response.policyowner.name == '' || this.response.policyowner.name == 'null' || this.response.policyowner.name == null) {
        this.nameDiv = false;
        this.cmndef.presentAlert("", this.languageConext.SelectApp.checkowner, "invalid");
      } else {
        this.normaldropdown = true;
        this.nomineedropdown = false;
        this.appointeedropdown = false;
        this.oldname = this.response.policyowner.name;
        this.nameDiv = true;
      }
    }
    else if (selected === 'policyinsured') {
      console.log(this.response.policyinsured);
      if (this.response.policyinsured == undefined || this.response.policyinsured == '' || this.response.policyinsured.name === 'null' || this.response.policyinsured.name === null) {
        this.nameDiv = false;
        this.cmndef.presentAlert("", this.languageConext.SelectApp.checkAssured, "invalid");

      } else {
        this.normaldropdown = true;
        this.nomineedropdown = false;
        this.appointeedropdown = false;
        this.nameDiv = true;
        this.oldname = this.response.policyinsured.name;
      }
    }
    else if (selected === 'nominee') {
      if (this.response.nominee.length > 0) {
        this.normaldropdown = false;
        this.nomineedropdown = true;
        this.appointeedropdown = false;
        this.nominees = this.response.nominee;
        this.nameDiv = true;
        this.oldname = this.response.nominee[0].name;
      } else if (this.response.nominee.name == undefined || this.response.nominee.name == '' || this.response.nominee.name == 'null' || this.response.nominee.name == null) {
        this.nameDiv = false;
        this.cmndef.presentAlert("", this.languageConext.SelectApp.checkNominee, "invalid");
      } else if (this.response.nominee.name != 'null') {
        this.normaldropdown = true;
        this.nomineedropdown = false;
        this.appointeedropdown = false;
        this.nameDiv = true;
        this.oldname = this.response.nominee.name;
      }
    }
    else if (selected === 'appointee') {
      if (this.response.appointee.length > 0) {
        this.normaldropdown = false;
        this.nomineedropdown = false;
        this.appointeedropdown = true;
        this.appointees = this.response.appointee;
        this.nameDiv = true;
        console.log(this.appointees);
        this.oldname = this.response.appointee[0].name;
      } else if (this.response.appointee.name == undefined || this.response.appointee.name == '' || this.response.appointee.name == 'null' || this.response.appointee.name == null) {
        this.nameDiv = false;
        if (this.response.nominee.length > 0 || (this.response.nominee.name != undefined && this.response.nominee.name != '' && this.response.nominee.name != 'null' && this.response.nominee.name != null))
          this.cmndef.presentAlert("", this.languageConext.SelectApp.no_nominee, "invalid");
        else
          this.cmndef.presentAlert("", this.languageConext.SelectApp.checkappointee, "invalid");
      } else if (this.response.appointee.name != 'null') {
        this.normaldropdown = true;
        this.nomineedropdown = false;
        this.appointeedropdown = false;
        this.nameDiv = true;
        this.oldname = this.response.appointee.name;
      }
    }
  }

  // change name
  checkname() {
    if (this.oldname != undefined && this.newname != undefined) {
      if (this.oldname.toUpperCase() == this.newname.toUpperCase()) {
        return true;
      }
      else {
        return false;
      }
    } else
      return false;
  }// change name  

  imgs() {
    this.FronImgName = "";
    this.FrontImgFile = "";
    this.BackImgFile = "";
    this.BackImgName = "";
    this.agreecheck = false;
    this.file1 = {};
    this.file2 = {};
    if (this.selproof == "Aadhaar") {
      this.TrustFrontImgFile = 'assets/images/aadhaar.png';
      this.TrustBackImgFile = 'assets/images/aadhaar.png';
    } else if (this.selproof == "Voter Id") {
      this.TrustFrontImgFile = 'assets/images/voter-id-card.png';
      this.TrustBackImgFile = 'assets/images/voterback.png';
    } else if (this.selproof == "Driving License") {
      this.TrustFrontImgFile = 'assets/images/drive.png';
      this.TrustBackImgFile = 'assets/images/driveback.png';
    } else if (this.selproof == "PAN Card") {
      this.TrustFrontImgFile = 'assets/images/panuploadIcon.PNG';
    } else if (this.selproof == "Passport") {
      this.TrustFrontImgFile = 'assets/images/passportfront.jfif';
      this.TrustBackImgFile = 'assets/images/passportback.jpg';
    } else if (this.selproof == "NREGA Job Card") {
      this.TrustFrontImgFile = 'assets/images/naregasample.png';
      this.TrustBackImgFile = 'assets/images/naregasample1.png';
    }
  }

  imgs_additional() {
    if (this.selproofAdditional == "marrcertificate") {
      this.additionalprooftrustimgs = 'assets/images/marriagecertSample.jpg';
    } else if (this.selproofAdditional == "GazetteCertificate") {
      this.additionalprooftrustimgs = 'assets/images/gazettesampleImg.jpg';
    } else if (this.selproofAdditional == "newspaperAdv") {
      this.additionalprooftrustimgs = 'assets/images/newspapersampleimg.jpg';
    }
    this.additionalproofimgs = [];
    this.AddtionalFile = false;
  }

  ngOnInit() {
  }

  pickImage(sourceType, flg) {
    let date = new Date();
    const options: CameraOptions = {
      quality: localStorage.imagequality,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    };
    this.FileSelected = flg;
    this.camera.getPicture(options).then(async (imageData) => {
      if (this.platform.is('ios')) {
        await this.statusBar.overlaysWebView(true);
        await this.statusBar.overlaysWebView(false);
      }
      let base64Image = 'data:image/jpeg;base64,' + imageData;
      let stringLength: number = Number(imageData.length);
      let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
      let sizeInMB = sizeInBytes / 1000000;
      if (Math.floor(sizeInMB) <= Number(localStorage.imgsize)) {
        if (imageData.indexOf("file:/") != -1) {
          this.base64.encodeFile(imageData).then((base64File: string) => {
            if (this.FileSelected == "front") {
              this.FronImgName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
              this.TrustFrontImgFile = this._sanitizer.bypassSecurityTrustUrl(base64File);
              this.FrontImgFile = base64File;
              this.file1.fileContent = base64File;
              this.file1.fileContentName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
              this.file1.fileContentType = this.selproof;

            } else {
              this.BackImgName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
              this.BackImgFile = base64File;
              this.TrustBackImgFile = this._sanitizer.bypassSecurityTrustUrl(base64File);
              this.file2.fileContent = base64File;
              this.file2.fileContentName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
              this.file2.fileContentType = this.selproof;
            }
          });
        } else {
          if (this.FileSelected == "front") {
            this.FronImgName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
              this.TrustFrontImgFile = this._sanitizer.bypassSecurityTrustUrl(base64Image);
            this.FrontImgFile = base64Image;
            this.file1.fileContentName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
              this.file1.fileContent = base64Image;
            this.file1.fileContentType = this.selproof;

          } else {
            this.BackImgName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
              this.TrustBackImgFile = this._sanitizer.bypassSecurityTrustUrl(base64Image);
            this.BackImgFile = base64Image;
            this.file2.fileContentName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
              this.file2.fileContent = base64Image;
            this.file2.fileContentType = this.selproof;
          }
        }
      } else
        this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
    }, async (err) => {
      if (this.platform.is('ios')) {
        await this.statusBar.overlaysWebView(true);
        await this.statusBar.overlaysWebView(false);
      }
    });
  }

  async selectImage(flg: any) {
    //  this.FileSelected = flg
    this.cmndeclaration.Actionsheetenable = true;
    const actionSheet = await this.actionSheetController.create({
      header: "Select Image source",
      buttons: [{
        text: 'Load from Library',
        handler: () => {
          this.cmndeclaration.Actionsheetenable = false;
          if (this.cmndeclaration.runPlatform == 'ios')
            this.IOSFileselect(flg);
          else
            this.Fileselect(flg);
        }
      }, {
        text: 'Use Camera',
        handler: () => {
          this.cmndeclaration.Actionsheetenable = false;
          this.pickImage(this.camera.PictureSourceType.CAMERA, flg);
        }
      }, {
        text: 'Cancel',
        role: 'cancel',
        handler: () => {
          this.cmndeclaration.Actionsheetenable = false;
        }
      }]
    });
    await actionSheet.present();
  }


  async uploadadditionalproof(flg: any) {
    this.cmndeclaration.Actionsheetenable = true;
    const actionSheet = await this.actionSheetController.create({
      header: "Select Image source",
      buttons: [{
        text: 'Load from Library',
        handler: () => {
          this.cmndeclaration.Actionsheetenable = false;
          if (this.cmndeclaration.runPlatform == "ios")
            this.IOSFileselectadditional(flg);
          else
            this.Fileselectadditional(flg);
        }
      }, {
        text: 'Use Camera',
        handler: () => {
          this.cmndeclaration.Actionsheetenable = false;
          this.pickImageadditional(this.camera.PictureSourceType.CAMERA, flg);
        }
      }, {
        text: 'Cancel',
        role: 'cancel',
        handler: () => {
          this.cmndeclaration.Actionsheetenable = false;
        }
      }]
    });
    await actionSheet.present();

  }
  Fileselectadditional(flg) {
    let stringLength: any;
    let validFormate: any;
    if (this.platform.is('android')) {
      this.fileChooser.open()
        .then(
          uri => {
            this.filePath.resolveNativePath(uri)
              .then(url => {
                var fileName = url.substring(url.lastIndexOf("/") + 1);
                validFormate = url.substring(url.lastIndexOf("."), url.length);
                console.log(validFormate);
                if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
                  this.base64.encodeFile(url).then((base64File: string) => {
                    if (validFormate.toLowerCase() == ".pdf") {
                      stringLength = base64File.indexOf("64,") + 3;
                      base64File = "data:application/pdf;base64," + base64File.substring(stringLength, base64File.length);
                      stringLength = base64File.length - 'data:application/pdf;base64,'.length;
                    } else
                      stringLength = base64File.length - 'data:image/png;base64,'.length;
                    let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                    let sizeInMB = sizeInBytes / 1000000;
                    if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                      this.AddtionalFile = true;
                      if (validFormate.toLowerCase() == ".pdf") {
                        this.additionalprooftrustimgs = "assets/images/pdfimg.PNG"
                      }
                      else {
                        this.additionalprooftrustimgs = this._sanitizer.bypassSecurityTrustUrl(base64File);
                      }
                      this.additionalproofimgs.push({
                        "fileContent": base64File,
                        "fileContentName": fileName,
                        "fileContentType": this.selproofAdditional
                      })
                    } else {
                      this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
                    }
                  });
                } else {
                  this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
                }

              })
              .catch(err => console.log(err));
          }
        )
        .catch(error => {
          console.log(error)
        });
    }
  }

  pickImageadditional(sourceType, flg) {
    let date = new Date();
    const options: CameraOptions = {
      quality: localStorage.imagequality,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    }
    this.camera.getPicture(options).then(async (imageData) => {
      if (this.platform.is('ios')) {
        await this.statusBar.overlaysWebView(true);
        await this.statusBar.overlaysWebView(false);
      }
      let base64Image = 'data:image/jpeg;base64,' + imageData;
      let stringLength: number = Number(imageData.length);
      let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
      let sizeInMB = sizeInBytes / 1000000;
      if (Math.floor(sizeInMB) <= Number(localStorage.imgsize)) {
        this.AddtionalFile = true;
        if (imageData.indexOf("file:/") != -1) {
          this.base64.encodeFile(imageData).then((base64File: string) => {
            this.additionalprooftrustimgs = base64File;
            this.additionalproofimgs.push(
              {
                "fileContent": base64File,
                "fileContentName": imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length),
                "fileContentType": this.selproofAdditional
              })
          });
        } else {
          this.additionalprooftrustimgs = base64Image;
          this.additionalproofimgs.push(
            {
              "fileContent": base64Image,
              "fileContentName": "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
              "fileContentType": this.selproofAdditional
            })
        }
      } else
        this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
    }, async (err) => {
      if (this.platform.is('ios')) {
        await this.statusBar.overlaysWebView(true);
        await this.statusBar.overlaysWebView(false);
      }
    });
  }


  Fileselect(flg) {
    let stringLength: any;
    let validFormate: any;
    if (this.platform.is('android')) {
      this.fileChooser.open()
        .then(
          uri => {
            this.filePath.resolveNativePath(uri)
              .then(url => {
                var fileName = url.substring(url.lastIndexOf("/") + 1);
                validFormate = url.substring(url.lastIndexOf("."), url.length);
                console.log(validFormate);
                if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
                  this.base64.encodeFile(url).then((base64File: string) => {
                    if (validFormate.toLowerCase() == ".pdf") {
                      stringLength = base64File.indexOf("64,") + 3;
                      base64File = "data:application/pdf;base64," + base64File.substring(stringLength, base64File.length);
                      stringLength = base64File.length - 'data:application/pdf;base64,'.length;
                    } else
                      stringLength = base64File.length - 'data:image/png;base64,'.length;
                    let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                    let sizeInMB = sizeInBytes / 1000000;
                    if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {

                      if (flg == "front") {
                        this.FronImgName = fileName;
                        if (validFormate.toLowerCase() == ".pdf") {
                          this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
                        }
                        else {
                          this.TrustFrontImgFile = this._sanitizer.bypassSecurityTrustUrl(base64File);
                          this.FrontImgFile = base64File;
                        }

                        this.file1.fileContent = base64File;
                        this.file1.fileContentName = fileName;
                        this.file1.fileContentType = this.selproof;
                      }
                      else if (flg == "back" && (this.selproof == 'Driving License' || this.selproof == 'Aadhaar' || this.selproof == 'Voter Id' || this.selproof == 'Passport' || this.selproof == 'NREGA Job Card')) {
                        this.BackImgName = fileName;
                        if (validFormate.toLowerCase() == ".pdf") {
                          this.TrustBackImgFile = "assets/images/pdfimg.PNG"
                        }
                        else {
                          this.TrustBackImgFile = this._sanitizer.bypassSecurityTrustUrl(base64File);
                          this.BackImgFile = base64File;
                        }
                        this.file2.fileContent = base64File;
                        this.file2.fileContentName = fileName;
                        this.file2.fileContentType = this.selproof;
                      }
                    } else {
                      this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
                    }
                  });
                } else {
                  this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
                }

              })
              .catch(err => console.log(err));
          }
        )
        .catch(error => {
          console.log(error)
        });
    }
  }
  async IOSFileselect(flg) {
    let filePath: any;
    let fileName: any;
    let path: any;
    let validFormate: any;
    let stringLength: any;
    await this.iosfilepicker.pickFile().then(async uri => {
      filePath = "file://" + uri;
      fileName = filePath.split('/').pop();
      path = filePath.substring(0, filePath.lastIndexOf("/") + 1);
      this.file.readAsDataURL(path, fileName).then(base64File => {
        sessionStorage.demo = base64File;
        validFormate = fileName.substring(fileName.lastIndexOf("."), fileName.length);
        if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
          stringLength = base64File.substring(base64File.indexOf("64,") + 3, base64File.length);
          stringLength = stringLength.length;
          console.log(stringLength);
          let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
          let sizeInMB = sizeInBytes / 1000000;
          if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
            if (flg == "recentphoto") {
              this.file1.fileContent = base64File;
              this.file1.fileContentName = fileName;
            }
            else if (flg == "front") {
              this.FronImgName = fileName;
              if (validFormate.toLowerCase() == ".pdf") {
                this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
              }

              else {
                this.TrustFrontImgFile = this._sanitizer.bypassSecurityTrustUrl(base64File);
                this.FrontImgFile = base64File;
              }
              this.file1.fileContent = base64File;
              this.file1.fileContentName = fileName;
              this.file1.fileContentType = this.selproof;
            }
            else if (flg == "back" && (this.selproof == 'Driving License' || this.selproof == 'Aadhaar' || this.selproof == 'Voter Id' || this.selproof == 'Passport' || this.selproof == 'NREGA Job Card')) {
              this.BackImgName = fileName;
              if (validFormate.toLowerCase() == ".pdf") {
                this.TrustBackImgFile = "assets/images/pdfimg.PNG"
              }

              else {
                this.TrustBackImgFile = this._sanitizer.bypassSecurityTrustUrl(base64File);
                this.BackImgFile = base64File;
              }
              this.file2.fileContent = base64File;
              this.file2.fileContentName = fileName;
              this.file2.fileContentType = this.selproof;
            }

          } else
            this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid");
        } else
          this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid");
      })
        .catch(() => {
          console.log('Error reading file');
        })
    })
      .catch(err => console.log('Error', err));
  }

  async IOSFileselectadditional(flg) {
    let filePath: any;
    let fileName: any;
    let path: any;
    let validFormate: any;
    let stringLength: any;
    await this.iosfilepicker.pickFile().then(async uri => {
      filePath = "file://" + uri;
      fileName = filePath.split('/').pop();
      path = filePath.substring(0, filePath.lastIndexOf("/") + 1);
      this.file.readAsDataURL(path, fileName).then(base64File => {
        sessionStorage.demo = base64File;
        validFormate = fileName.substring(fileName.lastIndexOf("."), fileName.length);
        if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
          stringLength = base64File.substring(base64File.indexOf("64,") + 3, base64File.length);
          stringLength = stringLength.length;
          console.log(stringLength);
          let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
          let sizeInMB = sizeInBytes / 1000000;
          if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
            this.AddtionalFile = true;
            if (validFormate.toLowerCase() == ".pdf") {
              this.additionalprooftrustimgs = "assets/images/pdfimg.PNG"
            }
            else {
              this.additionalprooftrustimgs = this._sanitizer.bypassSecurityTrustUrl(base64File);
            }
            this.additionalproofimgs.push({
              "fileContent": base64File,
              "fileContentName": fileName,
              "fileContentType": this.selproofAdditional
            })
          } else
            this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid");
        } else
          this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid");
      })
        .catch(() => {
          console.log('Error reading file');
        })
    })
      .catch(err => console.log('Error', err));
  }








  // For Browser
  changeListener($event, flg): void {
    let name: any;
    let validFormate: any;
    let imgname: any;
    let sizeInBytes: any;
    let stringLength: any;
    let sizeInMB: any;
    name = $event.target.files[0].name;
    this.FileSelected = flg;
    validFormate = name.substring(name.lastIndexOf("."), name.length);

    console.log(validFormate);
    if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
      this.cmndef.readThis($event.target).then(data => {
        imgname = data;
        stringLength = imgname.length - imgname.indexOf("64,") + 3;
        sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
        sizeInMB = sizeInBytes / 1000000;
        console.log(sizeInMB);
        if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
          if (flg == "front") {
            this.FronImgName = name;
            if (validFormate.toLowerCase() == ".pdf") {
              this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
            }

            else {
              this.TrustFrontImgFile = this._sanitizer.bypassSecurityTrustUrl(imgname);
              this.FrontImgFile = imgname;
            }

            this.file1.fileContent = imgname;
            this.file1.fileContentName = name;
            this.file1.fileContentType = this.selproof;
          }
          else if (flg == "back" && (this.selproof == 'Driving License' || this.selproof == 'Aadhaar' || this.selproof == 'Voter Id' || this.selproof == 'Passport' || this.selproof == 'NREGA Job Card')) {
            this.BackImgName = name;
            if (validFormate.toLowerCase() == ".pdf") {
              this.TrustBackImgFile = "assets/images/pdfimg.PNG"
            }

            else {
              this.TrustBackImgFile = this._sanitizer.bypassSecurityTrustUrl(imgname);
              this.BackImgFile = imgname;
            }
            this.file2.fileContent = imgname;
            this.file2.fileContentName = name;
            this.file2.fileContentType = this.selproof;
          }

        } else {
          this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
        }
      })
    } else {
      this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
    }
  }

  // For Browser
  changeListenerAdd($event, flg): void {
    let name: any;
    let validFormate: any;
    let imgname: any;
    let sizeInBytes: any;
    let stringLength: any;
    let sizeInMB: any;
    name = $event.target.files[0].name;
    this.FileSelected = flg;
    validFormate = name.substring(name.lastIndexOf("."), name.length);

    console.log(validFormate);
    if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
      this.cmndef.readThis($event.target).then(data => {
        imgname = data;
        stringLength = imgname.length - imgname.indexOf("64,") + 3;
        sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
        sizeInMB = sizeInBytes / 1000000;
        console.log(sizeInMB);
        if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
          this.AddtionalFile = true;
          if (flg == "front") {
            if (validFormate.toLowerCase() == ".pdf") {
              this.additionalprooftrustimgs = "assets/images/pdfimg.PNG"
            }
            else {
              this.additionalprooftrustimgs = this._sanitizer.bypassSecurityTrustUrl(imgname);
            }

            this.additionalproofimgs.push(
              {
                "fileContent": imgname,
                "fileContentName": name,
                "fileContentType": this.selproofAdditional
              })
          }

        } else {
          this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
        }
      })
    } else {
      this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
    }
  }


  async changenamefun() {
    this.newname = this.newname.trim();
    if(this.newname != undefined && this.newname.length >=3){
      if (((this.changename.controls.applicable.valid == true
        && this.changename.controls.newname.valid == true
        && this.changename.controls.selproof.valid == true
        && (((this.selproofAdditional != '' && this.selproofAdditional != undefined && this.AddtionalFile == true) || (this.selproofAdditional == '' || this.selproofAdditional == undefined))
          && (this.selectedApplicable == "policyowner" || this.selectedApplicable == "policyinsured")) && ((this.selproof == 'Aadhaar' && this.file1.hasOwnProperty("fileContent") && this.file2.hasOwnProperty("fileContent") && this.agreecheck) || (this.selproof == 'Driving License' && this.file1.hasOwnProperty("fileContent") && this.file2.hasOwnProperty("fileContent")) || (this.selproof == 'Voter Id' && this.file1.hasOwnProperty("fileContent") && this.file2.hasOwnProperty("fileContent")) || (this.selproof == 'NREGA Job Card' && this.file1.hasOwnProperty("fileContent") && this.file2.hasOwnProperty("fileContent")) || (this.selproof == 'PAN Card' && this.file1.hasOwnProperty("fileContent")) || (this.selproof == 'Passport' && this.file1.hasOwnProperty("fileContent") && this.file2.hasOwnProperty("fileContent"))) && ((this.selproofAdditional != '' && this.selproofAdditional != undefined && this.AddtionalFile == true) || (this.selproofAdditional == '' || this.selproofAdditional == undefined))))
        || (this.changename.controls.applicable.valid == true
          && this.changename.controls.newname.valid == true
          && this.changename.controls.selproof.valid != true
          && (this.selectedApplicable != "policyowner" && this.selectedApplicable != "policyinsured"))) {
        this.combineimgary = [];
  
        this.cmndef.loaderstart();
        if (this.file1.hasOwnProperty("fileContent"))
          this.combineimgary.push(this.file1);
        if (this.file2.hasOwnProperty("fileContent"))
          this.combineimgary.push(this.file2);
        let finalObj = this.combineimgary.concat(this.additionalproofimgs);
        if (finalObj.length == 0) {
          finalObj = 'null';
        }
  
        this.cmndeclaration.DataStore = {
          "userSessionID": localStorage.userSessionID,
          "userChatSessionID": localStorage.userChatSessionId,
          "actionType": "NameUpdate",
          "actionVal": {
            "applicant": this.selectedApplicable,
            "applicantName": this.oldname,
            "oldname": this.oldname,
            "newName": this.newname,
            "actionVal": finalObj
          }
        }
  
        console.log(this.cmndeclaration.DataStore);
        this.api.clickenventcap("submit_" + this.cmndef.TrakcerFromValue[this.cmndef.router.url]);
        await this.api.postapi("akeiraVAAction", this.cmndeclaration.DataStore).then(async data => {
          let res = data;
          this.cmndef.loaderend();
          this.cmndeclaration.TamlismaJson = res["chatResp"][0];
          this.changename.reset();
          sessionStorage.CurrentPage = "/va/chat";
          this.navctrl.navigateForward("/va/chat");
        }, err => {
          console.log(err);
          this.cmndef.loaderend();
        })
      }
    }
  }
  
  Validatation(flg: any) {
    if (flg == "newnamee") {
      this.newname = this.newname.replace(/[^a-zA-Z ]+/g, '');
      this.newname = this.newname.replace("  ", ' ');
      if(this.newname.length == 1)
        this.newname = this.newname.replace(" ", '');
    }
  }
}
